import { createSlice } from "@reduxjs/toolkit";
import { tokenCheck } from "./services/dashboard.services";

const initialState = {
  loading: false,
  error: "",
  data: null,
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    // clearOTP: (state) => {
    //   state.otpData = initialState.otpData;
    // },
    // setResend: (state, action) => {
    //   state.resend = action.payload;
    // },
  },
  extraReducers: (builder) => {
    builder.addCase(tokenCheck.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(tokenCheck.fulfilled, (state) => {
      state.loading = false;
      state.error = "";
    });
    builder.addCase(tokenCheck.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});
// export const { clearOTP, setResend } = dashboardSlice.actions;
export default dashboardSlice.reducer;
